/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/vue-echarts/~/lodash/_freeGlobal.js
// module id = 1477
// module chunks = 45